import { useGetTourCategories } from 'api-hooks/tour-category';
import { NavigationRoutes } from 'common/constants';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useGetListParamsValue from 'hooks/use-get-list-params-value';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import UniskaiListTemplate from 'templates/list/uniskai-list-template';

export default function TourCategoryList() {
  const { queryPage } = useGetListParamsValue();
  const [page, setPage] = React.useState(queryPage);
  const { t } = useTranslation();
  const columns = React.useMemo(() => {
    return [
      {
        header: t('common:tour_type'),
        accessorKey: 'name',
        minSize: 250,
        sortName: 'name',
      },
      {
        header: t('common:description'),
        accessorKey: 'description',
        minSize: 250,
      },
    ];
  }, [t]);
  const permission = useGetCrudPermission('tour-categories');

  return (
    <UniskaiListTemplate
      addNavigation={NavigationRoutes.TourCategoryCreate}
      columns={columns}
      page={page}
      setPage={setPage}
      useQuery={useGetTourCategories}
      queryInput={{
        params: {
          page,
        },
      }}
      title={t(`pathname:${NavigationRoutes.TourCategoryList}`)}
      tableName={NavigationRoutes.TourCategoryList}
      rowLink={
        permission?.view
          ? (row) => ({
              pathname: NavigationRoutes.TourCategoryView,
              query: { id: row.original.id },
            })
          : undefined
      }
    />
  );
}
